// extracted by mini-css-extract-plugin
export default {"button":"UwwiisPsBb67y9KZs4Yw"};